import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { connectMediaStore, useMMSelector, useMMDispatchActions } from './withOwnReduxStore';
import { setCurrentTierId, unsetCurrentTierId } from '../actions';
import { getCurrentTierId, getCurrentTier } from '../selectors';
export const useCurrentTier = ()=>_object_spread({}, useMMSelector((state)=>({
            currentTierId: getCurrentTierId(state),
            currentTier: getCurrentTier(state)
        })), useMMDispatchActions({
        setCurrentTierId,
        unsetCurrentTierId
    }));
export default ((component)=>connectMediaStore((state)=>({
            currentTierId: getCurrentTierId(state),
            currentTier: getCurrentTier(state)
        }), {
        setCurrentTierId,
        unsetCurrentTierId
    })(component)); // redux typings are a bit dumb with generics
